//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "module-detail",
  data(){
    return{
      moduleId:null,
      moduleObj:{},
      selectModel:'base'
    }
  },
  methods:{
    getModule(){
      this.$loadingShow();
      this.$get(`api/mould/${this.moduleId}`).then((res) => {
        if(res){
          this.moduleObj = res;
        }
        this.$loadingHide();
      }).catch(() => {
        this.$loadingHide();
      })
    },
    changeShowModel(str){
      this.selectModel = str;
    }
  },
  mounted(){
    this.moduleId = this.$route.params.id;
    this.getModule();
  }
}



// WEBPACK FOOTER //
// ./src/page/procu-syner/module-detail.vue